<template>
	<div class="left bg-white ">
		<div class="flex justify-between align-center left-item height56 solid-bottom padding-lr pointer" v-for="(item,index) in typelist" :key="index" :class="index == typeindex?'text-theme active':''" @click="chose(item,index)">
			<p>{{item.name}}</p>
			<i class="el-icon-arrow-right"></i>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			return {
				typeindex:0,//选中的左侧下标
				typelist:[
					{
						name:'个人中心',
						type:'myself',
						id:1,
					},{
						name:'发布租赁',
						id:1,
						type:'lease'
					},{
						name:'租赁管理',
						type:'leaselist',
						id:1,
					},{
						name:'发布招标',
						type:'bidding',
						id:1,
					},{
						name:'招标管理',
						type:'tender',
						id:1,
					},
          {
            name:'供应商管理',
            type:'adminsupply',
            id:1,
          },
          {
						name:'企业认证',
						type:'enterprise',
						id:1,
					},{
						name:'售课权限',
						type:'authority',
						id:1,
					},{
						name:'关于蓝友',
						type:'about',
						id:2,
					},{
						name:'发票记录',
						id:1,
						type:'recordt'
					},{
						name:'申请发票',
						type:'apply',
						id:1,
					},{
						name:'广告合作',
						type:'advert',
						id:2,
					},{
						name:'问题反馈',
						type:'feedback',
						id:1,
					},{
						name:'设置密码',
						type:'setpassword',
						id:1,
					},
				],//左侧列表
			}
		},
		created() {
			Bus.$on('backmy',()=>{
				this.typeindex = 0
			})
		},
		destroyed() {
			Bus.$off()
		},
		methods: {
			/**
			 * 选择跳转组件
			 * item object 选中的组件
			 * index number 选中的下标
			 * */
			chose(item,index){
				if(item.id == 1){
					this.typeindex = index
					if(item.type){
						let type = {
							type:item.type,
							typeone:''
						}
						this.$emit('gettype',type)
					}
				}else{
					this.$router.push({
						name:item.type,

					})
				}
			},
      // 二次修改侧边栏选中
      changeIndex(index){
        this.typeindex = index
      }

		}
	}
</script>

<style scoped lang="less">
	.left{
		width: 260px;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2000);
		border-radius: 20px;
		min-height: 676px;
	}
	.height56{
		height: 56px;
	}
	.active{
		border-bottom: 1px solid #09827B;
	}
	.left-item:last-child{
		border: 0 !important;
	}
</style>



// WEBPACK FOOTER //
// src/view/my/myleft.vue